import Factory from './factory';

export default new Factory()
    .addProp('options', Array)
    .addProp('showEmpty', Boolean)
	.addProp('required', Boolean)
    .addPassthrough('options')
    .addPassthrough('showEmpty')
	.addPassthrough('required');
